(() => {
  const FLAG_OFFSET = 127397;

  const flagFromCode = (code) => {
    const normalized = String(code || '').trim().toUpperCase();
    if (!/^[A-Z]{2}$/.test(normalized)) return '🌐';
    return Array.from(normalized)
      .map((letter) => String.fromCodePoint(FLAG_OFFSET + letter.charCodeAt(0)))
      .join('');
  };

  const paintFlags = (scope = document) => {
    scope.querySelectorAll('[data-country-flag][data-country-code], [data-country-selected-flag][data-country-code]')
      .forEach((element) => {
        element.textContent = flagFromCode(element.dataset.countryCode);
      });
  };

  const initializeModal = (modal) => {
    if (modal.dataset.countryModalReady === 'true') return;
    modal.dataset.countryModalReady = 'true';

    const trigger = document.querySelector('[aria-controls="' + modal.id + '"]');
    const closeButtons = modal.querySelectorAll('[data-country-close]');
    const select = modal.querySelector('[data-country-select]');
    let previousFocus = null;

    if (!trigger) return;

    const openModal = () => {
      previousFocus = document.activeElement;
      modal.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('lumerune-country-modal-open');
      const closeButton = modal.querySelector('.lumerune-country-modal__close');
      if (closeButton) closeButton.focus();
    };

    const closeModal = () => {
      modal.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('lumerune-country-modal-open');
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
    };

    trigger.addEventListener('click', openModal);
    closeButtons.forEach((button) => button.addEventListener('click', closeModal));

    if (select) {
      Array.from(select.options).forEach((option) => {
        if (option.dataset.flagReady === 'true') return;
        option.dataset.flagReady = 'true';
        option.textContent = flagFromCode(option.value) + '  ' + option.textContent.trim();
      });

    }

    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeModal();
        return;
      }

      if (event.key !== 'Tab') return;
      const focusable = Array.from(
        modal.querySelectorAll('button:not([disabled]), select:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])')
      ).filter((element) => !element.hidden);
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  };

  const initialize = (scope = document) => {
    paintFlags(scope);
    scope.querySelectorAll('[data-country-modal]').forEach(initializeModal);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
